<div class="left-col" [class.disabled]="timelineDisabled">
  <div class="stats">
    <div class="time">
      <div>
        <label>In:</label
        ><span>{{
          selectedClip ? formatTime(selectedClip.inMs) : "--:--:--.---"
        }}</span>
      </div>
      <div>
        <label>Out:</label
        ><span>{{
          selectedClip ? formatTime(selectedClip.outMs) : "--:--:--.---"
        }}</span>
      </div>
    </div>
  </div>
  <div class="tracks-labels">
    <div
      *ngFor="let label of trackLabels"
      [class.disabled]="disabledTracks.has(label)"
      [class.track-label-large]="label === 'Video' || label === 'Audio'"
      class="track-label-row"
    >
      <span [class.track-label-faded]="isTrackLabelFaded(label)">{{
        label
      }}</span>
      <div
        *ngIf="label === 'Audio'"
        class="audio-track-controls"
        (click)="$event.stopPropagation()"
      >
        <div class="audio-track-select" [class.open]="audioTrackMenuOpen">
          <button
            type="button"
            class="audio-track-select-trigger"
            [disabled]="mainAudioTracks.length === 0"
            [attr.title]="mainAudioSelectionFullLabel"
            (click)="toggleAudioTrackMenu($event)"
          >
            <span class="audio-track-select-label">{{
              mainAudioSelectionTruncatedLabel
            }}</span>
            <span class="audio-track-select-chevron" aria-hidden="true"></span>
          </button>
          <ul
            *ngIf="audioTrackMenuOpen && mainAudioTracks.length > 0"
            class="audio-track-select-menu"
            role="listbox"
          >
            <li
              role="option"
              [class.selected]="selectedMainAudioMediaId == null"
              [attr.title]="'default'"
              (click)="onSelectMainAudioTrack(null, $event)"
            >
              default
            </li>
            <li
              *ngFor="let track of mainAudioTracks"
              role="option"
              [class.selected]="selectedMainAudioMediaId === track.id"
              [attr.title]="trackFullLabel(track)"
              (click)="onSelectMainAudioTrack(track.id, $event)"
            >
              {{ trackTruncatedLabel(track) }}
            </li>
          </ul>
        </div>
        <button
          type="button"
          class="audio-mute-btn"
          [class.muted]="audioMuted"
          [attr.title]="audioMuted ? 'Unmute audio' : 'Mute audio'"
          (click)="onAudioMuteClick()"
        >
          <svg
            *ngIf="!audioMuted"
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path
              d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"
            />
          </svg>
          <svg
            *ngIf="audioMuted"
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path
              d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"
            />
          </svg>
        </button>
      </div>
    </div>
  </div>
</div>
<div class="right-col" [class.disabled]="timelineDisabled">
  <div
    #timeline
    class="timeline"
    (mousemove)="onMouseMove($event)"
    (mouseleave)="onMouseLeave()"
    (mousedown)="onTimelineMouseDown($event)"
  >
    <div class="timers">
      <span>{{
        displayTimeMs != null ? formatTime(displayTimeMs) : "--:--:--.---"
      }}</span>
      <span>{{ durationMs ? formatTime(durationMs) : "--:--:--.---" }}</span>
    </div>
    <div #playhead class="playhead">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 12 11"
        height="11"
        width="12"
        (mousedown)="onPlayheadMouseDown($event)"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0H12V6L6 10.5834L0 6V0Z"
          fill="black"
        />
      </svg>
      <svg
        class="playhead-line"
        [attr.height]="playheadLineHeight"
        width="1.5"
        xmlns="http://www.w3.org/2000/svg"
        shape-rendering="crispEdges"
        [attr.viewBox]="'0 0 1.5 ' + playheadLineHeight"
      >
        <rect
          width="1"
          [attr.height]="playheadLineHeight"
          fill="black"
          vector-effect="non-scaling-stroke"
        />
      </svg>
    </div>
    <div #segments class="segments">
      <div
        class="mam-segment-fills"
        *ngIf="mamSegmentFillRanges.length"
        aria-hidden="true"
      >
        <div
          *ngFor="let fill of mamSegmentFillRanges"
          class="mam-fill-segment"
          [class.mam-fill-odd]="fill.isOdd"
          [class.mam-fill-even]="!fill.isOdd"
          [style.left.%]="fill.leftPercent"
          [style.width.%]="fill.widthPercent"
        ></div>
      </div>
      <div
        class="pending-region"
        *ngIf="pendingRegion && isSourceMode"
        [style.left.%]="pendingRegion.left"
        [style.width.%]="pendingRegion.width"
      ></div>
      <div
        class="mark-indicator mark-in"
        *ngIf="pendingInPercent != null && isSourceMode"
        [style.left.%]="pendingInPercent"
      ></div>
      <div
        class="mark-indicator mark-out"
        *ngIf="pendingOutPercent != null && isSourceMode"
        [style.left.%]="pendingOutPercent"
      ></div>
      <div
        class="source-boundary-marker"
        *ngFor="let pos of sourceBoundaryPositionsPercent"
        [style.left.%]="pos"
        title="Source boundary"
      ></div>
      <!-- Highlight selected segment in source mode (main cuts and appended-MAM cuts; not Edit-only MAM). -->
      <div
        class="clip-segment selected"
        *ngIf="isSourceMode && selectedClip && isSourceTimelineClip(selectedClip)"
        [style.left.%]="getClipPosition(selectedClip).left"
        [style.width.%]="getClipPosition(selectedClip).width"
        (mousedown)="onClipClick(selectedClip.id, $event)"
        [title]="selectedClip.label"
      ></div>
    </div>
    <div
      class="tooltip"
      *ngIf="showTooltip"
      [class.tooltip-with-thumb]="tooltipThumbnailStyle"
      [ngStyle]="{
        'top.px': tooltipPosition.y,
        'left.px': tooltipPosition.x,
      }"
    >
      <div
        *ngIf="tooltipThumbnailStyle"
        class="tooltip-thumb"
        [ngStyle]="tooltipThumbnailStyle"
      ></div>
      <div class="tooltip-label">
        <span>{{ tooltipFormattedCurrentTime }}</span>
      </div>
    </div>
    <ng-container *ngIf="!useSegmentRuler; else segmentRulerScroll">
      <cdk-virtual-scroll-viewport
        #timelineVirtualScroll
        class="scroll-zone"
        [itemSize]="timelineBlockWidth"
        orientation="horizontal"
      >
        <div
          *cdkVirtualFor="let timeBlock of timeBlocks"
          class="time-block"
          [style.width.px]="timeBlock.width"
        >
          <div class="time-label-container">
            <span class="time-label">
              {{ timeBlock.timestamp }}
            </span>
          </div>
          <svg [attr.width]="timeBlock.width" height="37" class="block-svg">
            <g *ngFor="let tick of timeBlock.ticks">
              <line
                [attr.x1]="tick.x"
                [attr.y1]="tick.y1"
                [attr.x2]="tick.x"
                [attr.y2]="tick.y2"
                [attr.stroke-width]="tick.width"
                stroke="#737E8C"
              ></line>
            </g>
          </svg>
        </div>
      </cdk-virtual-scroll-viewport>
    </ng-container>
    <ng-template #segmentRulerScroll>
      <div #timelineScrollZone class="scroll-zone scroll-zone--native">
        <div
          *ngFor="let timeBlock of timeBlocks"
          class="time-block"
          [style.width.px]="timeBlock.width"
        >
          <div class="time-label-container">
            <span class="time-label">
              {{ timeBlock.timestamp }}
            </span>
          </div>
          <svg [attr.width]="timeBlock.width" height="37" class="block-svg">
            <g *ngFor="let tick of timeBlock.ticks">
              <line
                [attr.x1]="tick.x"
                [attr.y1]="tick.y1"
                [attr.x2]="tick.x"
                [attr.y2]="tick.y2"
                [attr.stroke-width]="tick.width"
                stroke="#737E8C"
              ></line>
            </g>
          </svg>
        </div>
      </div>
    </ng-template>
  </div>

  <div
    #tracks
    class="tracks"
    cdkDropList
    id="timeline-mam-drop-zone"
    [cdkDropListData]="mamDropListData"
    (cdkDropListDropped)="onMamDrop($event)"
    (mousemove)="emptyEventAction($event)"
    (mouseleave)="emptyEventAction($event)"
    (mousedown)="onTracksMouseDown($event)"
  >
    <!-- Video track (large — room for thumbnail strip) -->
    <div #track class="track track-large">
      <ng-container *ngIf="isSourceMode">
        <div
          class="clip-bar"
          *ngFor="let clip of sourceModeClips"
          [style.left.%]="getClipPosition(clip).left"
          [style.width.%]="getClipPosition(clip).width"
          [class.selected]="clip.id === state?.selectedClipId"
          (click)="onClipClick(clip.id, $event)"
        >
          <div
            *ngIf="clip.thumbnailFirstFrameUrl || clip.thumbnailLastFrameUrl"
            class="segment-thumbnails"
          >
            <img
              *ngIf="clip.thumbnailFirstFrameUrl"
              class="segment-thumbnail segment-thumbnail--first"
              [src]="clip.thumbnailFirstFrameUrl"
              [alt]="clip.label + ' first frame'"
            />
            <img
              *ngIf="clip.thumbnailLastFrameUrl"
              class="segment-thumbnail segment-thumbnail--last"
              [src]="clip.thumbnailLastFrameUrl"
              [alt]="clip.label + ' last frame'"
            />
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="!isSourceMode">
        <div
          class="edit-clips-row"
          cdkDropList
          cdkDropListOrientation="horizontal"
          [cdkDropListData]="clipsByOrder"
          (cdkDropListDropped)="onClipsDrop($event)"
        >
          <div
            class="edit-clip-bar"
            *ngFor="let clip of clipsByOrder"
            cdkDrag
            [style.flex-grow]="getEditClipFlex(clip)"
            [class.selected]="clip.id === state?.selectedClipId"
            (click)="onClipClick(clip.id, $event)"
          >
            <div
              *ngIf="clip.thumbnailFirstFrameUrl || clip.thumbnailLastFrameUrl"
              class="segment-thumbnails"
            >
              <img
                *ngIf="clip.thumbnailFirstFrameUrl"
                class="segment-thumbnail segment-thumbnail--first"
                [src]="clip.thumbnailFirstFrameUrl"
                [alt]="clip.label + ' first frame'"
              />
              <span class="clip-label" [title]="clip.label">{{ clip.label }}</span>
              <img
                *ngIf="clip.thumbnailLastFrameUrl"
                class="segment-thumbnail segment-thumbnail--last"
                [src]="clip.thumbnailLastFrameUrl"
                [alt]="clip.label + ' last frame'"
              />
            </div>
            <span
              *ngIf="!clip.thumbnailFirstFrameUrl && !clip.thumbnailLastFrameUrl"
              class="clip-label"
              [title]="clip.label"
              >{{ clip.label }}</span
            >
          </div>
        </div>
      </ng-container>
    </div>

    <!-- Markers track -->
    <div #track class="track">
      <evrideo-clipping-studio-timeline-marker
        *ngFor="let marker of displayMarkers"
        [marker]="marker"
        [leftPercent]="getMarkerPercent(marker)"
        [selected]="marker.id === state?.selectedMarkerId"
        [isMamSourceMarker]="!!marker.appendedSegmentId"
        [style.left.%]="getMarkerPercent(marker)"
        (markerClick)="onMarkerClick($event)"
        (textChange)="onMarkerTextChange(marker, $event)"
      ></evrideo-clipping-studio-timeline-marker>
    </div>

    <!-- Subtitles track: segment bars in SOURCE and EDIT mode; same source as transcript panel -->
    <div #track class="track" [class.disabled]="isTrackDisabled('Subtitles')">
      <div
        class="clip-bar"
        *ngFor="let sub of subtitleSegments"
        [style.left.%]="getSubtitleSegmentPosition(sub).left"
        [style.width.%]="getSubtitleSegmentPosition(sub).width"
        [class.selected]="sub.id === state?.selectedSubtitleId"
        [attr.title]="sub.Text"
        (click)="onSubtitleSegmentClick(sub, $event)"
      >
        <span class="subtitle-segment-label">{{ sub.Text }}</span>
      </div>
    </div>

    <!-- Text track: segment bars in edit mode; click to focus in timeline and sidebar -->
    <div #track class="track" [class.disabled]="isTrackDisabled('Text')">
      <ng-container *ngIf="!isSourceMode">
        <div
          class="clip-bar"
          *ngFor="let te of textSegments"
          [style.left.%]="getTextSegmentPosition(te).left"
          [style.width.%]="getTextSegmentPosition(te).width"
          [class.selected]="te.id === state?.selectedTextId"
          (click)="onTextSegmentClick(te, $event)"
        ></div>
      </ng-container>
    </div>

    <!-- Graphics track: segment bars in edit mode -->
    <div #track class="track" [class.disabled]="isTrackDisabled('Graphics')">
      <ng-container *ngIf="!isSourceMode">
        <div
          class="clip-bar"
          *ngFor="let g of graphicSegments"
          [style.left.%]="getGraphicSegmentPosition(g).left"
          [style.width.%]="getGraphicSegmentPosition(g).width"
          [class.selected]="g.id === state?.selectedGraphicId"
          (click)="onGraphicSegmentClick(g, $event)"
        ></div>
      </ng-container>
    </div>

    <!-- Audio track (large — same height as Video) -->
    <div
      #track
      class="track track-large"
      [class.disabled]="isTrackDisabled('Audio')"
    ></div>
  </div>
</div>
